module.exports = __webpack_public_path__ + "media/category_icons/Musculoskeletal-980e623d.svg";